export const state = {
	//contact us data
	contact_us:[],
	// countriesList : [],
	citiesList : [],
	//coupon
	couponList : [],
	sunPlanList : [],
	subExistList : [],
	subPlanDetail : [],
	
	//reporting
	reportingList : [],
	emirList : [],
	
	//email
	emailList : [],
	
	//admin
	adminList : [],
	adminDetail : [],
	
	//client
	catList : [],
	articleList : [],
	
	ibList : [],
	userList : [],
	userView : [],
	logsList : [],
	logsView : [],
	userCount : [],
	empStatus : {'01' : 'Employed','02' : 'Self-Employed','03' :'Unemployed','04' : 'Student' ,'05' :'Retired'},
	occupation :{'01' : 'Director','02' : 'Head/Manager of a Department','03' :'Partner','04' : 'Office Manager' ,'05' :'Admin/Secretarial' , '06' : 'Professional Staff', '07' : 'Accountant', '08' : 'Caretaker', '09' : 'Other'},
	estYearlyIncome : {'01' : '< 25k','02' : '25k - 50k','03' :'50k - 100k','04' : '100k - 250k' ,'05' :'250k - 500k','06' : '> 500k'},
	estNetWorth : {'01' : '< €25k ','02' : '€25k - €50k ','03' :'€50k - €100k ','04' : '€100k  - €250k ' ,'05' :'€250k  - €500k ','06' :'> €500k '},
	antAccountTurnover : {'01' : '€0 - €10k','02' :'€10k - €50k','03' :'€50k -€100k','04' :'€100k - €250k' ,'05' :'€250k - €500k','06' : '€500k +'},
	genderList : {'Male' : 'male' , 'Female' : 'female'},
	roleList : {'0' : 'User' , '1' : 'Restricted User'},
	idenVerList : [{'key': '01' , 'value' : 'Face to Face Identification and Verification' }, {'key':'02' ,'value': 'Non Face to Face Identification and Verification = Original or Certified True Copies of  KYC'} ,  {'key' : '03' , 'value' : 'Non Face to Face Identification and Verification - Compliance with Section 2 of Fourth Appendix of Directive = Plain Copies of Originals'}, {'key' : '04', 'value' : 'Non Face to Face Identification and Verification - NOT in compliance with Section 2 of Fourth Appendix of Directive = Plain Copies of Originals'}, {'key' : '05', 'value' : 'No KYC provided/Failed to Verify Client/Client Unwilling to Provide'}],
	credInsList : [{'key' :'01' , 'value': 'EU/EEA Credit Institution (Regulated)' }, {'key' :'02' , 'value': 'EU/ EEA Financial Institution/Payment Institution (Regulated)'}, {'key' :'03' , 'value':  'EU/ EEA E-Wallet (Regulated)'},{'key' :'04' , 'value': 'EU/FATF - High Risk Country/Sanction List/Corruption List/Panama papers =Credit Institution/Financial Institution/Payment Institution/E-Wallet (Regulated & Unregulated)'},{'key' :'05' , 'value': 'Other 3rd Country Credit/Financial Institution/Payment Institution/E-Wallet  (Unregulated)'},{'key' :'06' , 'value':  'Other 3rd Country Credit/Financial Institution/Payment Institution/E-Wallet (Regulated)'}],
	thrdPartyList : [{'key' : '01' , 'value' : 'No such risk. The Company at all times requests for Power of Attorney stating the Authorised Representative(s) of the Account'}],
	
	
	
	fundSrcList : {'01' : 'Client' , '02' : 'Third Party','03' : 'Anonymous'},
	deptMethdList : {'01':'Credit Institution (Wire Transfer)','02' : 'Credit/Debit Card' , '03' : 'Financial Instritution/Payment Institution','04' : 'E-Wallet/Electronic Money','05' : 'Cash'},
	
	chnlRiskList : {'01' : 'Employee/Senior Management Recommendation/Meeting' , '02' : 'Introduction from existing client whose AML Risk is Low/Medium','03' : 'Intrdocution via Tied Agent, Affiliate, Introducer, Agent','04' : 'Online, no communication, own initiative'},
	
	stepList : {'0':'New Registeration','1':'Personal Information', '2':'Financial Details', '3':' Knowledge Experience', '4':'Declaration', '5':'Upload Personal Documents'},
	timeZone : {'Asia/Kolkata' : 'India' , 'Europe/Nicosia' : 'Cyprus' , 'Europe/London' : 'UK'},
	
	internalNotes : [],
	riskMetrix : [],

	//ticket
	ticketList : [],
	ticketView : [],
	ticketDocs : [],
	ticketDocsLink : "https://login.hankotrade.com:2087/get/docs?type=",
	//ticketDocsLink : "https://dev.finvasia.com:7001/get/docs?type=", 
	downloadUserZip : "https://admin.fxview.com:2087/get/zip?id=",
	ticketStatus: {'0' : 'open', '1' : 'doc verified', '2' : 'cancel', '3' : 'close'},
	ticketReason: {'1' : 'Document Upload' ,'2' :'Email Change' , '3' : 'Mobile Number Change'},
	ticketReasonList : [],
	// department_list : [
	// 	{'id' : '4','description' : 'Sales' , 'role' : 'SL'},
	// 	{'id' : '5','description' : 'Customer Support' , 'role' : 'CS'},
	// 	{'id' : '6','description' : 'Back Office' , 'role' : 'BO'},
	// 	{'id' : '7','description' : 'Accounts' , 'role' : 'AC'},
	// 	{'id' : '8','description' : 'IT' , 'role' : 'IT'},
	// 	{'id' : '9','description' : 'Demat Department' , 'role' : 'DP'},
	// ],
	department_list : [
		{'id' : '3','description' : 'Reporting Manager' , 'role' : 'RM'},
		{'id' : '4','description' : 'Back Office - Admin' , 'role' : 'BO-A'},
		{'id' : '5','description' : 'Back Office - Manager' , 'role' : 'BO-M'},
		{'id' : '6','description' : 'Back Office' , 'role' : 'BO'},
		{'id' : '7','description' : 'Accounts - Admin' , 'role' : 'AC-A'},
		{'id' : '8','description' : 'Accounts - Manager' , 'role' : 'AC-M'},
		{'id' : '9','description' : 'Accounts' , 'role' : 'AC'},
		{'id' : '10','description' : 'IT' , 'role' : 'IT'},
		{'id' : '11','description' : 'Customer Support' , 'role' : 'CS'},
		{'id' : '18','description' : 'Reporting Manager - Admin' , 'role' : 'RM-A'},
		{'id' : '19','description' : 'Reporting Manager - Manager' , 'role' : 'RM-M'},
		{'id' : '20','description' : 'RMS' , 'role' : 'RMS'},
		{'id' : '21','description' : 'RMS - Admin' , 'role' : 'RMS-A'},
		{'id' : '22','description' : 'RMS - Manager' , 'role' : 'RMS-M'},
	],  
	//deposit
	depositList : [],
	depositTransaction : [],
	depositView : [],
	depositStatus : {'-1' : 'Transaction Initiated', '0' : 'pending' ,'1' :'success', '2' :'Decilned','3':"Decilned", '4': "unverified account"},
	depositMethod : {'1' : 'Bank' ,'2' :'Skrill', '3' : 'Neteller','4' : 'Trading Account', '5': 'Credit Card'},
	
	//commission
	commissionList : [],
	commissionView : [],
	
	//bonus
	bonusList : [],
	bonusView : [],
	
	//withdrawal
	withdrawalList : [],
	withdrawalView : [],
	withdrawalType : {'1' : 'Withdrawal' ,'2' :'Internal Transfer','3' :'Subscription'},
	withdrawalMethods : {'1' : 'bank_transfer.png' ,'2' :'skrill.png', '3' : 'neteller.png','5': 'CreditCardVias.svg', '6': "Giropay.svg", '7':"przelewy-24.svg", '8': "rapid-transfer.svg", '9': 'Nordea.svg', '10': 'Klarna.svg'},
	withdrawalMethod : {'1' : 'bank transfer' ,'2' :'skrill', '3' : 'neteller','4' : 'Trading Account', '5': 'Credit Card'},
	withdrawalMethodResponse : [],
	withdrawalStatus : {'0' : 'pending', '1':'processed', '2':'rejected'}, 
	
	notifications : [],

	//trading
	tradingList : [],
	tradingView : [],
	demoLive : {'0' : 'demo' , '1' : 'live'},
	currency : {'EUR' : 'eur.svg','USD' : 'usd.svg','GBP' : 'gbp.svg','CHF' : 'chf.svg','JPY' : 'jpy.svg','AUD' : 'aud.svg'},
	/*leverage : {'01' : '100X' , '02' : '200X' , '03' : '300X'},
	currency : {'01':'USD','02':'GBP'},
	accountType : {'01' : 'ECN'},*/   //user later

	//bonus
	bonusType : {'1' : 'Add Bonus' ,'2' :'Remove Bonus'},
	bonusStatus : {'0' : 'open' , '1' : 'processed'},

	// bonus booster
	bbCampaignList: [],
	bbCampaignDetail: {},
	bbCodeList: [],
	bbCodeDetail: {},
	bbRedemptionList: [],
	bbRedemptionDetail: {},
	countriesList : [
		{ "name": "Afghanistan", "code": "AF" },
		{ "name": "Albania", "code": "AL" },
		{ "name": "Algeria", "code": "DZ" },
		{ "name": "American Samoa", "code": "AS" },
		{ "name": "AndorrA", "code": "AD" },
		{ "name": "Angola", "code": "AO" },
		{ "name": "Anguilla", "code": "AI" },
		{ "name": "Antarctica", "code": "AQ" },
		{ "name": "Antigua and Barbuda", "code": "AG" },
		{ "name": "Argentina", "code": "AR" },
		{ "name": "Armenia", "code": "AM" },
		{ "name": "Aruba", "code": "AW" },
		{ "name": "Australia", "code": "AU" },
		{ "name": "Austria", "code": "AT" },
		{ "name": "Azerbaijan", "code": "AZ" },
		{ "name": "Bahamas", "code": "BS" },
		{ "name": "Bahrain", "code": "BH" },
		{ "name": "Bangladesh", "code": "BD" },
		{ "name": "Barbados", "code": "BB" },
		{ "name": "Belarus", "code": "BY" },
		{ "name": "Belgium", "code": "BE" },
		{ "name": "Belize", "code": "BZ" },
		{ "name": "Benin", "code": "BJ" },
		{ "name": "Bermuda", "code": "BM" },
		{ "name": "Bhutan", "code": "BT" },
		{ "name": "Bolivia", "code": "BO" },
		{ "name": "Bosnia and Herzegovina", "code": "BA" },
		{ "name": "Botswana", "code": "BW" },
		{ "name": "Bouvet Island", "code": "BV" },
		{ "name": "Brazil", "code": "BR" },
		{ "name": "British Indian Ocean Territory", "code": "IO" },
		{ "name": "Brunei Darussalam", "code": "BN" },
		{ "name": "Bulgaria", "code": "BG" },
		{ "name": "Burkina Faso", "code": "BF" },
		{ "name": "Burundi", "code": "BI" },
		{ "name": "Cambodia", "code": "KH" },
		{ "name": "Cameroon", "code": "CM" },
		{ "name": "Canada", "code": "CA" },
		{ "name": "Cape Verde", "code": "CV" },
		{ "name": "Cayman Islands", "code": "KY" },
		{ "name": "Central African Republic", "code": "CF" },
		{ "name": "Chad", "code": "TD" },
		{ "name": "Chile", "code": "CL" },
		{ "name": "China", "code": "CN" },
		{ "name": "Christmas Island", "code": "CX" },
		{ "name": "Cocos (Keeling) Islands", "code": "CC" },
		{ "name": "Colombia", "code": "CO" },
		{ "name": "Comoros", "code": "KM" },
		{ "name": "Congo", "code": "CG" },
		{ "name": "Congo, The Democratic Republic of the", "code": "CD" },
		{ "name": "Cook Islands", "code": "CK" },
		{ "name": "Costa Rica", "code": "CR" },
		{ "name": "Cote DIvoire", "code": "CI" },
		{ "name": "Croatia", "code": "HR" },
		{ "name": "Cuba", "code": "CU" },
		{ "name": "Cyprus", "code": "CY" },
		{ "name": "Czech Republic", "code": "CZ" },
		{ "name": "Denmark", "code": "DK" },
		{ "name": "Djibouti", "code": "DJ" },
		{ "name": "Dominica", "code": "DM" },
		{ "name": "Dominican Republic", "code": "DO" },
		{ "name": "Ecuador", "code": "EC" },
		{ "name": "Egypt", "code": "EG" },
		{ "name": "El Salvador", "code": "SV" },
		{ "name": "Equatorial Guinea", "code": "GQ" },
		{ "name": "Eritrea", "code": "ER" },
		{ "name": "Estonia", "code": "EE" },
		{ "name": "Ethiopia", "code": "ET" },
		{ "name": "Falkland Islands (Malvinas)", "code": "FK" },
		{ "name": "Faroe Islands", "code": "FO" },
		{ "name": "Fiji", "code": "FJ" },
		{ "name": "Finland", "code": "FI" },
		{ "name": "France", "code": "FR" },
		{ "name": "French Guiana", "code": "GF" },
		{ "name": "French Polynesia", "code": "PF" },
		{ "name": "French Southern Territories", "code": "TF" },
		{ "name": "Gabon", "code": "GA" },
		{ "name": "Gambia", "code": "GM" },
		{ "name": "Georgia", "code": "GE" },
		{ "name": "Germany", "code": "DE" },
		{ "name": "Ghana", "code": "GH" },
		{ "name": "Gibraltar", "code": "GI" },
		{ "name": "Greece", "code": "GR" },
		{ "name": "Greenland", "code": "GL" },
		{ "name": "Grenada", "code": "GD" },
		{ "name": "Guadeloupe", "code": "GP" },
		{ "name": "Guam", "code": "GU" },
		{ "name": "Guatemala", "code": "GT" },
		{ "name": "Guernsey", "code": "GG" },
		{ "name": "Guinea", "code": "GN" },
		{ "name": "Guinea-Bissau", "code": "GW" },
		{ "name": "Guyana", "code": "GY" },
		{ "name": "Haiti", "code": "HT" },
		{ "name": "Heard Island and Mcdonald Islands", "code": "HM" },
		{ "name": "Holy See (Vatican City State)", "code": "VA" },
		{ "name": "Honduras", "code": "HN" },
		{ "name": "Hong Kong", "code": "HK" },
		{ "name": "Hungary", "code": "HU" },
		{ "name": "Iceland", "code": "IS" },
		{ "name": "India", "code": "IN" },
		{ "name": "Indonesia", "code": "ID" },
		{ "name": "Iran, Islamic Republic Of", "code": "IR" },
		{ "name": "Iraq", "code": "IQ" },
		{ "name": "Ireland", "code": "IE" },
		{ "name": "Isle of Man", "code": "IM" },
		{ "name": "Israel", "code": "IL" },
		{ "name": "Italy", "code": "IT" },
		{ "name": "Jamaica", "code": "JM" },
		{ "name": "Japan", "code": "JP" },
		{ "name": "Jersey", "code": "JE" },
		{ "name": "Jordan", "code": "JO" },
		{ "name": "Kazakhstan", "code": "KZ" },
		{ "name": "Kenya", "code": "KE" },
		{ "name": "Kiribati", "code": "KI" },
		{ "name": "Korea, Democratic PeopleS Republic of", "code": "KP" },
		{ "name": "Korea, Republic of", "code": "KR" },
		{ "name": "Kuwait", "code": "KW" },
		{ "name": "Kyrgyzstan", "code": "KG" },
		{ "name": "Lao PeopleS Democratic Republic", "code": "LA" },
		{ "name": "Latvia", "code": "LV" },
		{ "name": "Lebanon", "code": "LB" },
		{ "name": "Lesotho", "code": "LS" },
		{ "name": "Liberia", "code": "LR" },
		{ "name": "Libyan Arab Jamahiriya", "code": "LY" },
		{ "name": "Liechtenstein", "code": "LI" },
		{ "name": "Lithuania", "code": "LT" },
		{ "name": "Luxembourg", "code": "LU" },
		{ "name": "Macao", "code": "MO" },
		{ "name": "Macedonia, The Former Yugoslav Republic of", "code": "MK" },
		{ "name": "Madagascar", "code": "MG" },
		{ "name": "Malawi", "code": "MW" },
		{ "name": "Malaysia", "code": "MY" },
		{ "name": "Maldives", "code": "MV" },
		{ "name": "Mali", "code": "ML" },
		{ "name": "Malta", "code": "MT" },
		{ "name": "Marshall Islands", "code": "MH" },
		{ "name": "Martinique", "code": "MQ" },
		{ "name": "Mauritania", "code": "MR" },
		{ "name": "Mauritius", "code": "MU" },
		{ "name": "Mayotte", "code": "YT" },
		{ "name": "Mexico", "code": "MX" },
		{ "name": "Micronesia, Federated States of", "code": "FM" },
		{ "name": "Moldova, Republic of", "code": "MD" },
		{ "name": "Monaco", "code": "MC" },
		{ "name": "Mongolia", "code": "MN" },
		{ "name": "Montserrat", "code": "MS" },
		{ "name": "Morocco", "code": "MA" },
		{ "name": "Mozambique", "code": "MZ" },
		{ "name": "Myanmar", "code": "MM" },
		{ "name": "Namibia", "code": "NA" },
		{ "name": "Nauru", "code": "NR" },
		{ "name": "Nepal", "code": "NP" },
		{ "name": "Netherlands", "code": "NL" },
		{ "name": "Netherlands Antilles", "code": "AN" },
		{ "name": "New Caledonia", "code": "NC" },
		{ "name": "New Zealand", "code": "NZ" },
		{ "name": "Nicaragua", "code": "NI" },
		{ "name": "Niger", "code": "NE" },
		{ "name": "Nigeria", "code": "NG" },
		{ "name": "Niue", "code": "NU" },
		{ "name": "Norfolk Island", "code": "NF" },
		{ "name": "Northern Mariana Islands", "code": "MP" },
		{ "name": "Norway", "code": "NO" },
		{ "name": "Oman", "code": "OM" },
		{ "name": "Pakistan", "code": "PK" },
		{ "name": "Palau", "code": "PW" },
		{ "name": "Palestinian Territory, Occupied", "code": "PS" },
		{ "name": "Panama", "code": "PA" },
		{ "name": "Papua New Guinea", "code": "PG" },
		{ "name": "Paraguay", "code": "PY" },
		{ "name": "Peru", "code": "PE" },
		{ "name": "Philippines", "code": "PH" },
		{ "name": "Pitcairn", "code": "PN" },
		{ "name": "Poland", "code": "PL" },
		{ "name": "Portugal", "code": "PT" },
		{ "name": "Puerto Rico", "code": "PR" },
		{ "name": "Qatar", "code": "QA" },
		{ "name": "Reunion", "code": "RE" },
		{ "name": "Romania", "code": "RO" },
		{ "name": "Russian Federation", "code": "RU" },
		{ "name": "RWANDA", "code": "RW" },
		{ "name": "Saint Helena", "code": "SH" },
		{ "name": "Saint Kitts and Nevis", "code": "KN" },
		{ "name": "Saint Lucia", "code": "LC" },
		{ "name": "Saint Pierre and Miquelon", "code": "PM" },
		{ "name": "Saint Vincent and the Grenadines", "code": "VC" },
		{ "name": "Samoa", "code": "WS" },
		{ "name": "San Marino", "code": "SM" },
		{ "name": "Sao Tome and Principe", "code": "ST" },
		{ "name": "Saudi Arabia", "code": "SA" },
		{ "name": "Senegal", "code": "SN" },
		{ "name": "Serbia and Montenegro", "code": "CS" },
		{ "name": "Seychelles", "code": "SC" },
		{ "name": "Sierra Leone", "code": "SL" },
		{ "name": "Singapore", "code": "SG" },
		{ "name": "Slovakia", "code": "SK" },
		{ "name": "Slovenia", "code": "SI" },
		{ "name": "Solomon Islands", "code": "SB" },
		{ "name": "Somalia", "code": "SO" },
		{ "name": "South Africa", "code": "ZA" },
		{ "name": "South Georgia and the South Sandwich Islands", "code": "GS" },
		{ "name": "Spain", "code": "ES" },
		{ "name": "Sri Lanka", "code": "LK" },
		{ "name": "Sudan", "code": "SD" },
		{ "name": "Suriname", "code": "SR" },
		{ "name": "Svalbard and Jan Mayen", "code": "SJ" },
		{ "name": "Swaziland", "code": "SZ" },
		{ "name": "Sweden", "code": "SE" },
		{ "name": "Switzerland", "code": "CH" },
		{ "name": "Syrian Arab Republic", "code": "SY" },
		{ "name": "Taiwan, Province of China", "code": "TW" },
		{ "name": "Tajikistan", "code": "TJ" },
		{ "name": "Tanzania, United Republic of", "code": "TZ" },
		{ "name": "Thailand", "code": "TH" },
		{ "name": "Timor-Leste", "code": "TL" },
		{ "name": "Togo", "code": "TG" },
		{ "name": "Tokelau", "code": "TK" },
		{ "name": "Tonga", "code": "TO" },
		{ "name": "Trinidad and Tobago", "code": "TT" },
		{ "name": "Tunisia", "code": "TN" },
		{ "name": "Turkey", "code": "TR" },
		{ "name": "Turkmenistan", "code": "TM" },
		{ "name": "Turks and Caicos Islands", "code": "TC" },
		{ "name": "Tuvalu", "code": "TV" },
		{ "name": "Uganda", "code": "UG" },
		{ "name": "Ukraine", "code": "UA" },
		{ "name": "United Arab Emirates", "code": "AE" },
		{ "name": "United Kingdom", "code": "GB" },
		{ "name": "United States", "code": "US" },
		{ "name": "United States Minor Outlying Islands", "code": "UM" },
		{ "name": "Uruguay", "code": "UY" },
		{ "name": "Uzbekistan", "code": "UZ" },
		{ "name": "Vanuatu", "code": "VU" },
		{ "name": "Venezuela", "code": "VE" },
		{ "name": "Viet Nam", "code": "VN" },
		{ "name": "Virgin Islands, British", "code": "VG" },
		{ "name": "Virgin Islands, U.S.", "code": "VI" },
		{ "name": "Wallis and Futuna", "code": "WF" },
		{ "name": "Western Sahara", "code": "EH" },
		{ "name": "Yemen", "code": "YE" },
		{ "name": "Zambia", "code": "ZM" },
		{ "name": "Zimbabwe", "code": "ZW" }
	],
	referLinks : {
		home:"https://login.hankotrade.com?franchiseLead=",
		registration:"https://login.hankotrade.com/register?franchiseLead=",
		website:"https://hankotrade.com?franchiseLead=",
		promotional_bonuses :"https://hankotrade.com/100bonus?franchiseLead=",
		subIb:"https://affiliate.hankotrade.com/register?franchiseLead="
	}
}


// WEBPACK FOOTER //
// ./src/plugins/fxView/provider/candle-history/store-addons/state.js